module.exports = __webpack_public_path__ + "static/media/slim.c82e7352.svg";